import {
  FETCH_CONVERSATIONS_START, FETCH_CONVERSATIONS_SUCCESS, FETCH_CONVERSATIONS_ERROR,
  FETCH_MESSAGES_START, FETCH_MESSAGES_SUCCESS, FETCH_MESSAGES_ERROR,
  SEND_MESSAGE_SUCCESS, CREATE_CONVERSATION_SUCCESS, SET_TOTAL_UNREAD,
} from '../../Action/actionTypes'

const initialState = {
  conversations: [],
  conversationsLoading: true,   // true = not yet fetched; prevents acting on an empty list
  conversationsError: null,
  messagesByConvoId: {},
  messagesLoading: false,
  activeConvoId: null,
  totalUnread: 0,
}

const chatReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_CONVERSATIONS_START:
      return { ...state, conversationsLoading: true, conversationsError: null }
    case FETCH_CONVERSATIONS_SUCCESS: {
      const convos = action.payload.conversations ?? []
      const totalUnread = convos.reduce((sum, c) => sum + (c.unread_count ?? 0), 0)
      return { ...state, conversationsLoading: false, conversations: convos, totalUnread }
    }
    case FETCH_CONVERSATIONS_ERROR:
      return { ...state, conversationsLoading: false, conversationsError: action.payload }

    case SET_TOTAL_UNREAD:
      return { ...state, totalUnread: action.payload }

    case FETCH_MESSAGES_START:
      return { ...state, messagesLoading: true, activeConvoId: action.payload }
    case FETCH_MESSAGES_SUCCESS:
      return {
        ...state,
        messagesLoading: false,
        messagesByConvoId: {
          ...state.messagesByConvoId,
          [action.payload.conversationId]: action.payload.messages ?? [],
        },
      }
    case FETCH_MESSAGES_ERROR:
      return { ...state, messagesLoading: false }

    case SEND_MESSAGE_SUCCESS: {
      const { conversationId, message } = action.payload
      const existing = state.messagesByConvoId[conversationId] ?? []
      return {
        ...state,
        messagesByConvoId: {
          ...state.messagesByConvoId,
          [conversationId]: [...existing, message],
        },
      }
    }

    case CREATE_CONVERSATION_SUCCESS: {
      const convo = action.payload
      const exists = state.conversations.find((c) => c.id === convo.id)
      return {
        ...state,
        conversations: exists ? state.conversations : [convo, ...state.conversations],
      }
    }

    default:
      return state
  }
}

export default chatReducer
